// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduledCallsList-module__font-s-10___p7n0d {
  font-size: 10px !important;
}

.ScheduledCallsList-module__font-s-12___tHxnz {
  font-size: 12px !important;
}

.ScheduledCallsList-module__font-s-13___trHWR {
  font-size: 13px !important;
}

.ScheduledCallsList-module__font-s-14___k2Z3w {
  font-size: 14px !important;
}

.ScheduledCallsList-module__font-s-15___B3uRl {
  font-size: 15px !important;
}

.ScheduledCallsList-module__font-s-16___n88DH {
  font-size: 16px !important;
}

.ScheduledCallsList-module__font-s-18___ep824 {
  font-size: 18px !important;
}

.ScheduledCallsList-module__font-s-20___wFPPS {
  font-size: 20px !important;
}

.ScheduledCallsList-module__font-s-22___I6Z6D {
  font-size: 22px !important;
}

.ScheduledCallsList-module__font-s-28___m0eOv {
  font-size: 28px !important;
}

.ScheduledCallsList-module__font-w-400___TFWX8 {
  font-weight: 400 !important;
}

.ScheduledCallsList-module__font-w-500___GgKE1 {
  font-weight: 500 !important;
}

.ScheduledCallsList-module__font-w-600___Q_BXr {
  font-weight: 600 !important;
}

.ScheduledCallsList-module__font-w-700___IqfFo {
  font-weight: 700 !important;
}

.ScheduledCallsList-module__p-5___snwtT {
  padding: 5px !important;
}

.ScheduledCallsList-module__p-12___L7UsL {
  padding: 12px !important;
}

.ScheduledCallsList-module__p-16___I6f9w {
  padding: 16px !important;
}

.ScheduledCallsList-module__p-30___ey7Bp {
  padding: 30px !important;
}

.ScheduledCallsList-module__p-b-0___issua {
  padding-bottom: 0 !important;
}

.ScheduledCallsList-module__p-b-5___fKfps {
  padding-bottom: 5px !important;
}

.ScheduledCallsList-module__p-b-10___YqS45 {
  padding-bottom: 10px !important;
}

.ScheduledCallsList-module__p-b-12___CkWiB {
  padding-bottom: 12px !important;
}

.ScheduledCallsList-module__p-b-16___ZszKe {
  padding-bottom: 16px !important;
}

.ScheduledCallsList-module__p-b-18___vX4rL {
  padding-bottom: 18px !important;
}

.ScheduledCallsList-module__p-b-20___Twb5t {
  padding-bottom: 20px !important;
}

.ScheduledCallsList-module__p-b-25___C8dZa {
  padding-bottom: 25px !important;
}

.ScheduledCallsList-module__p-b-30___AvIxx {
  padding-bottom: 30px !important;
}

.ScheduledCallsList-module__p-b-50___XKF16 {
  padding-bottom: 50px !important;
}

.ScheduledCallsList-module__p-t-0___Qt0jV {
  padding-top: 0 !important;
}

.ScheduledCallsList-module__p-t-12___A8zBF {
  padding-top: 12px !important;
}

.ScheduledCallsList-module__p-t-16___lLev3 {
  padding-top: 16px !important;
}

.ScheduledCallsList-module__p-t-18___zWTzJ {
  padding-top: 18px !important;
}

.ScheduledCallsList-module__p-t-20___FsiSy {
  padding-top: 20px !important;
}

.ScheduledCallsList-module__p-t-30___JGBZD {
  padding-top: 30px !important;
}

.ScheduledCallsList-module__p-t-40___aysMA {
  padding-top: 40px !important;
}

.ScheduledCallsList-module__p-t-50___B_5YN {
  padding-top: 50px !important;
}

.ScheduledCallsList-module__p-l-20___uUbp_ {
  padding-left: 20px !important;
}

.ScheduledCallsList-module__p-l-30___gw_wB {
  padding-left: 30px !important;
}

.ScheduledCallsList-module__p-l-40___Cq8Gt {
  padding-left: 40px !important;
}

.ScheduledCallsList-module__p-r-16____Q05u {
  padding-right: 16px !important;
}

.ScheduledCallsList-module__p-r-20___Gek4Z {
  padding-right: 20px !important;
}

.ScheduledCallsList-module__p-r-30___zMYuh {
  padding-right: 30px !important;
}

.ScheduledCallsList-module__p-r-50___Yw_XA {
  padding-right: 50px !important;
}

.ScheduledCallsList-module__p-r-60___tqcS0 {
  padding-right: 60px !important;
}

.ScheduledCallsList-module__m-b-1___VHvE2 {
  margin-bottom: 1px !important;
}

.ScheduledCallsList-module__m-b-2___Pvhuu {
  margin-bottom: 2px !important;
}

.ScheduledCallsList-module__m-b-6___uSF5P {
  margin-bottom: 6px !important;
}

.ScheduledCallsList-module__m-b-8___wD4ji {
  margin-bottom: 8px !important;
}

.ScheduledCallsList-module__m-b-10___uXV2q {
  margin-bottom: 10px !important;
}

.ScheduledCallsList-module__m-b-14___n6RBc {
  margin-bottom: 14px !important;
}

.ScheduledCallsList-module__m-b-16___TXhbx {
  margin-bottom: 16px !important;
}

.ScheduledCallsList-module__m-b-20___lqGm9 {
  margin-bottom: 20px !important;
}

.ScheduledCallsList-module__m-b-22___g0HBR {
  margin-bottom: 22px !important;
}

.ScheduledCallsList-module__m-b-24___l_XLF {
  margin-bottom: 24px !important;
}

.ScheduledCallsList-module__m-b-30___qNzOs {
  margin-bottom: 30px !important;
}

.ScheduledCallsList-module__m-b-32___Gkzyl {
  margin-bottom: 32px !important;
}

.ScheduledCallsList-module__m-b-40___cuRyf {
  margin-bottom: 40px !important;
}

.ScheduledCallsList-module__m-t-2___LXiNs {
  margin-top: 2px !important;
}

.ScheduledCallsList-module__m-t-3___hkRBK {
  margin-top: 3px !important;
}

.ScheduledCallsList-module__m-t-4___emkFs {
  margin-top: 4px !important;
}

.ScheduledCallsList-module__m-t-5___Ae9jP {
  margin-top: 5px !important;
}

.ScheduledCallsList-module__m-t-8___SwS7o {
  margin-top: 8px !important;
}

.ScheduledCallsList-module__m-t-10___RuNgU {
  margin-top: 10px !important;
}

.ScheduledCallsList-module__m-t-15___HdKcR {
  margin-top: 15px !important;
}

.ScheduledCallsList-module__m-t-16___pWIGv {
  margin-top: 16px !important;
}

.ScheduledCallsList-module__m-t-20___NWVyS {
  margin-top: 20px !important;
}

.ScheduledCallsList-module__m-t-22___pf9bW {
  margin-top: 22px !important;
}

.ScheduledCallsList-module__m-t-30___nyJEj {
  margin-top: 30px !important;
}

.ScheduledCallsList-module__m-t-32___By9U8 {
  margin-top: 32px !important;
}

.ScheduledCallsList-module__m-l-auto___xiukh {
  margin-left: auto !important;
}

.ScheduledCallsList-module__m-l-4___vxcJv {
  margin-left: 4px !important;
}

.ScheduledCallsList-module__m-l-5___OJlHK {
  margin-left: 5px !important;
}

.ScheduledCallsList-module__m-l-6___aePFA {
  margin-left: 6px !important;
}

.ScheduledCallsList-module__m-l-8___odb8K {
  margin-left: 8px !important;
}

.ScheduledCallsList-module__m-l-10___pDwaw {
  margin-left: 10px !important;
}

.ScheduledCallsList-module__m-l-16___pYjDP {
  margin-left: 16px !important;
}

.ScheduledCallsList-module__m-l-20___CDJlS {
  margin-left: 20px !important;
}

.ScheduledCallsList-module__m-l-24___etZuL {
  margin-left: 24px !important;
}

.ScheduledCallsList-module__m-l-30___a_u3O {
  margin-left: 30px !important;
}

.ScheduledCallsList-module__m-l-35___AUnVJ {
  margin-left: 35px !important;
}

.ScheduledCallsList-module__m-l-40___PWoiS {
  margin-left: 40px !important;
}

.ScheduledCallsList-module__m-r-8___ln4tG {
  margin-right: 8px !important;
}

.ScheduledCallsList-module__m-r-10___kNF3n {
  margin-right: 10px !important;
}

.ScheduledCallsList-module__m-r-16___XWdo5 {
  margin-right: 16px !important;
}

.ScheduledCallsList-module__m-r-20___XKyRW {
  margin-right: 20px !important;
}

.ScheduledCallsList-module__m-r-24___k8TJv {
  margin-right: 24px !important;
}

.ScheduledCallsList-module__m-r-30___k682z {
  margin-right: 30px !important;
}

.ScheduledCallsList-module__m-r-40___FPfd1 {
  margin-right: 40px !important;
}

.ScheduledCallsList-module__border-r-3___kbEcL {
  border-radius: 3px !important;
}

.ScheduledCallsList-module__border-r-4___MOl08 {
  border-radius: 4px !important;
}

.ScheduledCallsList-module__border-r-6___Y9pyn {
  border-radius: 6px !important;
}

.ScheduledCallsList-module__border-r-10___WVtKP {
  border-radius: 10px !important;
}

.ScheduledCallsList-module__border-r-12___foj7H {
  border-radius: 12px !important;
}

.ScheduledCallsList-module__border-r-16____4Fla {
  border-radius: 16px !important;
}

.ScheduledCallsList-module__border-r-50___EZR6l {
  border-radius: 50% !important;
}

.ScheduledCallsList-module__primary-border___GzJCz {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledCallsList-module__primary-border-b___zIY3m {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledCallsList-module__primary-border-t___IetQO {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledCallsList-module__primary-border-l___ATgjc {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledCallsList-module__primary-border-r___SeEPl {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledCallsList-module__secondary-border___RjxZS {
  border: 1px solid #637768;
}

.ScheduledCallsList-module__secondary-border-b___La6zK {
  border-bottom: 1px solid #637768;
}

.ScheduledCallsList-module__secondary-border-t___WnnJN {
  border-top: 1px solid #637768;
}

.ScheduledCallsList-module__secondary-border-l___rr8cA {
  border-left: 1px solid #637768;
}

.ScheduledCallsList-module__secondary-border-r___mypM0 {
  border-right: 1px solid #637768;
}

.ScheduledCallsList-module__gap-0___uzE5R {
  gap: 0 !important;
}

.ScheduledCallsList-module__gap-2___iXwZm {
  gap: 2px !important;
}

.ScheduledCallsList-module__gap-4___wAVmD {
  gap: 4px !important;
}

.ScheduledCallsList-module__gap-5___W_pcc {
  gap: 5px !important;
}

.ScheduledCallsList-module__gap-6___P7T2T {
  gap: 6px !important;
}

.ScheduledCallsList-module__gap-8___pru3d {
  gap: 8px !important;
}

.ScheduledCallsList-module__gap-10___HYC2I {
  gap: 10px !important;
}

.ScheduledCallsList-module__gap-12___hKHpN {
  gap: 12px !important;
}

.ScheduledCallsList-module__gap-14___nAlJQ {
  gap: 14px !important;
}

.ScheduledCallsList-module__gap-16___pnPtd {
  gap: 16px !important;
}

.ScheduledCallsList-module__gap-18___QElXk {
  gap: 18px !important;
}

.ScheduledCallsList-module__gap-20___FqkF7 {
  gap: 20px !important;
}

.ScheduledCallsList-module__gap-24___C0qsd {
  gap: 24px !important;
}

.ScheduledCallsList-module__gap-26___tEoLT {
  gap: 26px !important;
}

.ScheduledCallsList-module__gap-30___adQPO {
  gap: 30px !important;
}

.ScheduledCallsList-module__gap-32___Dm4ME {
  gap: 32px !important;
}

.ScheduledCallsList-module__gap-40___aekFh {
  gap: 40px !important;
}

.ScheduledCallsList-module__gap-50___gzYus {
  gap: 50px !important;
}

.ScheduledCallsList-module__flex-1___cR99y {
  flex: 1;
}

.ScheduledCallsList-module__flex-none___ibF6J {
  flex: none !important;
}

.ScheduledCallsList-module__flex-column___BtaL6 {
  display: flex;
  flex-direction: column !important;
}

.ScheduledCallsList-module__flex-row___h76A7 {
  display: flex;
  flex-direction: row !important;
}

.ScheduledCallsList-module__vertically-centered___HE8id {
  display: flex;
  align-items: center !important;
}

.ScheduledCallsList-module__horizontally-centered___cG7VC {
  display: flex;
  justify-content: center !important;
}

.ScheduledCallsList-module__horizontally-end___VpUdT {
  display: flex;
  justify-content: end !important;
}

.ScheduledCallsList-module__vertically-start___ndpr7 {
  display: flex;
  align-items: start !important;
}

.ScheduledCallsList-module__space-between___DIJGs {
  display: flex;
  justify-content: space-between !important;
}

.ScheduledCallsList-module__flex-wrap___RCrS1 {
  flex-wrap: wrap !important;
}

.ScheduledCallsList-module__height-100___UUuL5 {
  height: 100%;
}

.ScheduledCallsList-module__width-50___jN89P {
  width: 50% !important;
}

.ScheduledCallsList-module__width-100____S3l5 {
  width: 100%;
}

.ScheduledCallsList-module__cursor-pointer___x6p14 {
  cursor: pointer;
}

.ScheduledCallsList-module__cursor-not-allowed___XWcZo {
  cursor: not-allowed !important;
}

.ScheduledCallsList-module__absolute-centered___zLqn0 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ScheduledCallsList-module__absolute___QYAgh {
  position: absolute;
}

.ScheduledCallsList-module__relative___IysW9 {
  position: relative;
}

.ScheduledCallsList-module__fixed___aKeT6 {
  position: fixed;
}

.ScheduledCallsList-module__visible___dHz6Y {
  opacity: 1;
}

.ScheduledCallsList-module__invisible___CMjwB {
  opacity: 0;
}

.ScheduledCallsList-module__col-90___vVlx1 {
  width: 90% !important;
}

.ScheduledCallsList-module__col-auto___ai1QY {
  width: auto !important;
}

.ScheduledCallsList-module__medical-tabs___jbJCf {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ScheduledCallsList-module__medical-table-new___l71wV {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ScheduledCallsList-module__medical-table-new___l71wV:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ScheduledCallsList-module__medical-table-new___l71wV::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ScheduledCallsList-module__medical-table-new___l71wV::-webkit-scrollbar-track {
  display: none;
}
.ScheduledCallsList-module__medical-table-new___l71wV.ScheduledCallsList-module__no-pagination___xu5fo {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ScheduledCallsList-module__medical-table-new___l71wV.ScheduledCallsList-module__no-pagination___xu5fo:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ScheduledCallsList-module__medical-table-new___l71wV.ScheduledCallsList-module__no-pagination___xu5fo::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ScheduledCallsList-module__medical-table-new___l71wV.ScheduledCallsList-module__no-pagination___xu5fo::-webkit-scrollbar-track {
  display: none;
}

.ScheduledCallsList-module__medical-table-empty___p9Xly {
  padding: 14px 40px !important;
}

.ScheduledCallsList-module__icon-btn___zwaKV {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ScheduledCallsList-module__search-icon___sCgPq {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ScheduledCallsList-module__disable-select___k01Sp {
  user-select: none;
}

.ScheduledCallsList-module__break-word___Cl81e {
  word-break: break-word;
}

.ScheduledCallsList-module__popup-clear-btn___ErhWC {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ScheduledCallsList-module__scroll-m-b-20___hKMck {
  scroll-margin-bottom: 20px;
}

.ScheduledCallsList-module__patientContainer___VFJ5e {
  display: flex;
  flex-direction: column;
}
.ScheduledCallsList-module__patientContainer___VFJ5e .ScheduledCallsList-module__table___P7vdt {
  width: 100%;
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination) - var(--scheduled-calls-header));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ScheduledCallsList-module__patientContainer___VFJ5e .ScheduledCallsList-module__table___P7vdt:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ScheduledCallsList-module__patientContainer___VFJ5e .ScheduledCallsList-module__table___P7vdt::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ScheduledCallsList-module__patientContainer___VFJ5e .ScheduledCallsList-module__table___P7vdt::-webkit-scrollbar-track {
  display: none;
}
.ScheduledCallsList-module__patientContainer___VFJ5e .ScheduledCallsList-module__table___P7vdt.ScheduledCallsList-module__noPagination___hld1k {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--scheduled-calls-header));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ScheduledCallsList-module__patientContainer___VFJ5e .ScheduledCallsList-module__table___P7vdt.ScheduledCallsList-module__noPagination___hld1k:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ScheduledCallsList-module__patientContainer___VFJ5e .ScheduledCallsList-module__table___P7vdt.ScheduledCallsList-module__noPagination___hld1k::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ScheduledCallsList-module__patientContainer___VFJ5e .ScheduledCallsList-module__table___P7vdt.ScheduledCallsList-module__noPagination___hld1k::-webkit-scrollbar-track {
  display: none;
}
.ScheduledCallsList-module__patientContainer___VFJ5e .ScheduledCallsList-module__table___P7vdt .ScheduledCallsList-module__empty___nEofb {
  padding: 14px 40px;
}

.ScheduledCallsList-module__nonPatientContainer___d24Og {
  display: flex;
  flex-direction: column;
}
.ScheduledCallsList-module__nonPatientContainer___d24Og .ScheduledCallsList-module__table___P7vdt {
  width: 100%;
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination) - 32px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.ScheduledCallsList-module__nonPatientContainer___d24Og .ScheduledCallsList-module__table___P7vdt:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ScheduledCallsList-module__nonPatientContainer___d24Og .ScheduledCallsList-module__table___P7vdt::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ScheduledCallsList-module__nonPatientContainer___d24Og .ScheduledCallsList-module__table___P7vdt::-webkit-scrollbar-track {
  display: none;
}
.ScheduledCallsList-module__nonPatientContainer___d24Og .ScheduledCallsList-module__table___P7vdt.ScheduledCallsList-module__noPagination___hld1k {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - 32px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.ScheduledCallsList-module__nonPatientContainer___d24Og .ScheduledCallsList-module__table___P7vdt.ScheduledCallsList-module__noPagination___hld1k:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ScheduledCallsList-module__nonPatientContainer___d24Og .ScheduledCallsList-module__table___P7vdt.ScheduledCallsList-module__noPagination___hld1k::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ScheduledCallsList-module__nonPatientContainer___d24Og .ScheduledCallsList-module__table___P7vdt.ScheduledCallsList-module__noPagination___hld1k::-webkit-scrollbar-track {
  display: none;
}
.ScheduledCallsList-module__nonPatientContainer___d24Og .ScheduledCallsList-module__table___P7vdt .ScheduledCallsList-module__empty___nEofb {
  padding: 14px 40px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/ScheduledCallsFragment/ScheduledCallsList/ScheduledCallsList.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,sBAAA;AA8pBF;AA5pBE;EACE,WAAA;ECGF,wNDDI;ECEJ,kBAAA;EACA,kBAAA;AD4pBF;AC1pBE;EACE,oCAAA;EACA,mBAAA;AD4pBJ;ACzpBE;EACE,UAAA;EACA,6BAAA;AD2pBJ;ACxpBE;EACE,aAAA;AD0pBJ;AAjqBI;ECRF,8LDUM;ECTN,kBAAA;EACA,kBAAA;AD4qBF;AC1qBE;EACE,oCAAA;EACA,mBAAA;AD4qBJ;ACzqBE;EACE,UAAA;EACA,6BAAA;AD2qBJ;ACxqBE;EACE,aAAA;AD0qBJ;AAvqBI;EACE,kBAAA;AAyqBN;;AApqBA;EACE,aAAA;EACA,sBAAA;AAuqBF;AArqBE;EACE,WAAA;EC7BF,+LD+BM;EC9BN,kBAAA;EACA,kBAAA;ADqsBF;ACnsBE;EACE,oCAAA;EACA,mBAAA;ADqsBJ;AClsBE;EACE,UAAA;EACA,6BAAA;ADosBJ;ACjsBE;EACE,aAAA;ADmsBJ;AA5qBI;ECtCF,qKDwCQ;ECvCR,kBAAA;EACA,kBAAA;ADqtBF;ACntBE;EACE,oCAAA;EACA,mBAAA;ADqtBJ;ACltBE;EACE,UAAA;EACA,6BAAA;ADotBJ;ACjtBE;EACE,aAAA;ADmtBJ;AAlrBI;EACE,kBAAA;AAorBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.patientContainer {\n  display: flex;\n  flex-direction: column;\n\n  .table {\n    width: 100%;\n    @include verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination) - var(\n            --scheduled-calls-header\n          )\n      )\n    );\n\n    &.noPagination {\n      @include verticalScroll(\n        calc(\n          100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n              --secondary-navigation\n            ) - var(--patient-details-footer) - var(--table-tabs) - var(--scheduled-calls-header)\n        )\n      );\n    }\n\n    .empty {\n      padding: 14px 40px;\n    }\n  }\n}\n\n.nonPatientContainer {\n  display: flex;\n  flex-direction: column;\n\n  .table {\n    width: 100%;\n    @include verticalScroll(\n        calc(\n          100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination) - 32px\n        )\n    );\n\n    &.noPagination {\n      @include verticalScroll(\n          calc(\n            100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n              --secondary-navigation\n            ) - var(--patient-details-footer) - var(--table-tabs) - 32px\n          )\n      );\n    }\n\n    .empty {\n      padding: 14px 40px;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ScheduledCallsList-module__font-s-10___p7n0d`,
	"fontS12": `ScheduledCallsList-module__font-s-12___tHxnz`,
	"fontS13": `ScheduledCallsList-module__font-s-13___trHWR`,
	"fontS14": `ScheduledCallsList-module__font-s-14___k2Z3w`,
	"fontS15": `ScheduledCallsList-module__font-s-15___B3uRl`,
	"fontS16": `ScheduledCallsList-module__font-s-16___n88DH`,
	"fontS18": `ScheduledCallsList-module__font-s-18___ep824`,
	"fontS20": `ScheduledCallsList-module__font-s-20___wFPPS`,
	"fontS22": `ScheduledCallsList-module__font-s-22___I6Z6D`,
	"fontS28": `ScheduledCallsList-module__font-s-28___m0eOv`,
	"fontW400": `ScheduledCallsList-module__font-w-400___TFWX8`,
	"fontW500": `ScheduledCallsList-module__font-w-500___GgKE1`,
	"fontW600": `ScheduledCallsList-module__font-w-600___Q_BXr`,
	"fontW700": `ScheduledCallsList-module__font-w-700___IqfFo`,
	"p5": `ScheduledCallsList-module__p-5___snwtT`,
	"p12": `ScheduledCallsList-module__p-12___L7UsL`,
	"p16": `ScheduledCallsList-module__p-16___I6f9w`,
	"p30": `ScheduledCallsList-module__p-30___ey7Bp`,
	"pB0": `ScheduledCallsList-module__p-b-0___issua`,
	"pB5": `ScheduledCallsList-module__p-b-5___fKfps`,
	"pB10": `ScheduledCallsList-module__p-b-10___YqS45`,
	"pB12": `ScheduledCallsList-module__p-b-12___CkWiB`,
	"pB16": `ScheduledCallsList-module__p-b-16___ZszKe`,
	"pB18": `ScheduledCallsList-module__p-b-18___vX4rL`,
	"pB20": `ScheduledCallsList-module__p-b-20___Twb5t`,
	"pB25": `ScheduledCallsList-module__p-b-25___C8dZa`,
	"pB30": `ScheduledCallsList-module__p-b-30___AvIxx`,
	"pB50": `ScheduledCallsList-module__p-b-50___XKF16`,
	"pT0": `ScheduledCallsList-module__p-t-0___Qt0jV`,
	"pT12": `ScheduledCallsList-module__p-t-12___A8zBF`,
	"pT16": `ScheduledCallsList-module__p-t-16___lLev3`,
	"pT18": `ScheduledCallsList-module__p-t-18___zWTzJ`,
	"pT20": `ScheduledCallsList-module__p-t-20___FsiSy`,
	"pT30": `ScheduledCallsList-module__p-t-30___JGBZD`,
	"pT40": `ScheduledCallsList-module__p-t-40___aysMA`,
	"pT50": `ScheduledCallsList-module__p-t-50___B_5YN`,
	"pL20": `ScheduledCallsList-module__p-l-20___uUbp_`,
	"pL30": `ScheduledCallsList-module__p-l-30___gw_wB`,
	"pL40": `ScheduledCallsList-module__p-l-40___Cq8Gt`,
	"pR16": `ScheduledCallsList-module__p-r-16____Q05u`,
	"pR20": `ScheduledCallsList-module__p-r-20___Gek4Z`,
	"pR30": `ScheduledCallsList-module__p-r-30___zMYuh`,
	"pR50": `ScheduledCallsList-module__p-r-50___Yw_XA`,
	"pR60": `ScheduledCallsList-module__p-r-60___tqcS0`,
	"mB1": `ScheduledCallsList-module__m-b-1___VHvE2`,
	"mB2": `ScheduledCallsList-module__m-b-2___Pvhuu`,
	"mB6": `ScheduledCallsList-module__m-b-6___uSF5P`,
	"mB8": `ScheduledCallsList-module__m-b-8___wD4ji`,
	"mB10": `ScheduledCallsList-module__m-b-10___uXV2q`,
	"mB14": `ScheduledCallsList-module__m-b-14___n6RBc`,
	"mB16": `ScheduledCallsList-module__m-b-16___TXhbx`,
	"mB20": `ScheduledCallsList-module__m-b-20___lqGm9`,
	"mB22": `ScheduledCallsList-module__m-b-22___g0HBR`,
	"mB24": `ScheduledCallsList-module__m-b-24___l_XLF`,
	"mB30": `ScheduledCallsList-module__m-b-30___qNzOs`,
	"mB32": `ScheduledCallsList-module__m-b-32___Gkzyl`,
	"mB40": `ScheduledCallsList-module__m-b-40___cuRyf`,
	"mT2": `ScheduledCallsList-module__m-t-2___LXiNs`,
	"mT3": `ScheduledCallsList-module__m-t-3___hkRBK`,
	"mT4": `ScheduledCallsList-module__m-t-4___emkFs`,
	"mT5": `ScheduledCallsList-module__m-t-5___Ae9jP`,
	"mT8": `ScheduledCallsList-module__m-t-8___SwS7o`,
	"mT10": `ScheduledCallsList-module__m-t-10___RuNgU`,
	"mT15": `ScheduledCallsList-module__m-t-15___HdKcR`,
	"mT16": `ScheduledCallsList-module__m-t-16___pWIGv`,
	"mT20": `ScheduledCallsList-module__m-t-20___NWVyS`,
	"mT22": `ScheduledCallsList-module__m-t-22___pf9bW`,
	"mT30": `ScheduledCallsList-module__m-t-30___nyJEj`,
	"mT32": `ScheduledCallsList-module__m-t-32___By9U8`,
	"mLAuto": `ScheduledCallsList-module__m-l-auto___xiukh`,
	"mL4": `ScheduledCallsList-module__m-l-4___vxcJv`,
	"mL5": `ScheduledCallsList-module__m-l-5___OJlHK`,
	"mL6": `ScheduledCallsList-module__m-l-6___aePFA`,
	"mL8": `ScheduledCallsList-module__m-l-8___odb8K`,
	"mL10": `ScheduledCallsList-module__m-l-10___pDwaw`,
	"mL16": `ScheduledCallsList-module__m-l-16___pYjDP`,
	"mL20": `ScheduledCallsList-module__m-l-20___CDJlS`,
	"mL24": `ScheduledCallsList-module__m-l-24___etZuL`,
	"mL30": `ScheduledCallsList-module__m-l-30___a_u3O`,
	"mL35": `ScheduledCallsList-module__m-l-35___AUnVJ`,
	"mL40": `ScheduledCallsList-module__m-l-40___PWoiS`,
	"mR8": `ScheduledCallsList-module__m-r-8___ln4tG`,
	"mR10": `ScheduledCallsList-module__m-r-10___kNF3n`,
	"mR16": `ScheduledCallsList-module__m-r-16___XWdo5`,
	"mR20": `ScheduledCallsList-module__m-r-20___XKyRW`,
	"mR24": `ScheduledCallsList-module__m-r-24___k8TJv`,
	"mR30": `ScheduledCallsList-module__m-r-30___k682z`,
	"mR40": `ScheduledCallsList-module__m-r-40___FPfd1`,
	"borderR3": `ScheduledCallsList-module__border-r-3___kbEcL`,
	"borderR4": `ScheduledCallsList-module__border-r-4___MOl08`,
	"borderR6": `ScheduledCallsList-module__border-r-6___Y9pyn`,
	"borderR10": `ScheduledCallsList-module__border-r-10___WVtKP`,
	"borderR12": `ScheduledCallsList-module__border-r-12___foj7H`,
	"borderR16": `ScheduledCallsList-module__border-r-16____4Fla`,
	"borderR50": `ScheduledCallsList-module__border-r-50___EZR6l`,
	"primaryBorder": `ScheduledCallsList-module__primary-border___GzJCz`,
	"primaryBorderB": `ScheduledCallsList-module__primary-border-b___zIY3m`,
	"primaryBorderT": `ScheduledCallsList-module__primary-border-t___IetQO`,
	"primaryBorderL": `ScheduledCallsList-module__primary-border-l___ATgjc`,
	"primaryBorderR": `ScheduledCallsList-module__primary-border-r___SeEPl`,
	"secondaryBorder": `ScheduledCallsList-module__secondary-border___RjxZS`,
	"secondaryBorderB": `ScheduledCallsList-module__secondary-border-b___La6zK`,
	"secondaryBorderT": `ScheduledCallsList-module__secondary-border-t___WnnJN`,
	"secondaryBorderL": `ScheduledCallsList-module__secondary-border-l___rr8cA`,
	"secondaryBorderR": `ScheduledCallsList-module__secondary-border-r___mypM0`,
	"gap0": `ScheduledCallsList-module__gap-0___uzE5R`,
	"gap2": `ScheduledCallsList-module__gap-2___iXwZm`,
	"gap4": `ScheduledCallsList-module__gap-4___wAVmD`,
	"gap5": `ScheduledCallsList-module__gap-5___W_pcc`,
	"gap6": `ScheduledCallsList-module__gap-6___P7T2T`,
	"gap8": `ScheduledCallsList-module__gap-8___pru3d`,
	"gap10": `ScheduledCallsList-module__gap-10___HYC2I`,
	"gap12": `ScheduledCallsList-module__gap-12___hKHpN`,
	"gap14": `ScheduledCallsList-module__gap-14___nAlJQ`,
	"gap16": `ScheduledCallsList-module__gap-16___pnPtd`,
	"gap18": `ScheduledCallsList-module__gap-18___QElXk`,
	"gap20": `ScheduledCallsList-module__gap-20___FqkF7`,
	"gap24": `ScheduledCallsList-module__gap-24___C0qsd`,
	"gap26": `ScheduledCallsList-module__gap-26___tEoLT`,
	"gap30": `ScheduledCallsList-module__gap-30___adQPO`,
	"gap32": `ScheduledCallsList-module__gap-32___Dm4ME`,
	"gap40": `ScheduledCallsList-module__gap-40___aekFh`,
	"gap50": `ScheduledCallsList-module__gap-50___gzYus`,
	"flex1": `ScheduledCallsList-module__flex-1___cR99y`,
	"flexNone": `ScheduledCallsList-module__flex-none___ibF6J`,
	"flexColumn": `ScheduledCallsList-module__flex-column___BtaL6`,
	"flexRow": `ScheduledCallsList-module__flex-row___h76A7`,
	"verticallyCentered": `ScheduledCallsList-module__vertically-centered___HE8id`,
	"horizontallyCentered": `ScheduledCallsList-module__horizontally-centered___cG7VC`,
	"horizontallyEnd": `ScheduledCallsList-module__horizontally-end___VpUdT`,
	"verticallyStart": `ScheduledCallsList-module__vertically-start___ndpr7`,
	"spaceBetween": `ScheduledCallsList-module__space-between___DIJGs`,
	"flexWrap": `ScheduledCallsList-module__flex-wrap___RCrS1`,
	"height100": `ScheduledCallsList-module__height-100___UUuL5`,
	"width50": `ScheduledCallsList-module__width-50___jN89P`,
	"width100": `ScheduledCallsList-module__width-100____S3l5`,
	"cursorPointer": `ScheduledCallsList-module__cursor-pointer___x6p14`,
	"cursorNotAllowed": `ScheduledCallsList-module__cursor-not-allowed___XWcZo`,
	"absoluteCentered": `ScheduledCallsList-module__absolute-centered___zLqn0`,
	"absolute": `ScheduledCallsList-module__absolute___QYAgh`,
	"relative": `ScheduledCallsList-module__relative___IysW9`,
	"fixed": `ScheduledCallsList-module__fixed___aKeT6`,
	"visible": `ScheduledCallsList-module__visible___dHz6Y`,
	"invisible": `ScheduledCallsList-module__invisible___CMjwB`,
	"col90": `ScheduledCallsList-module__col-90___vVlx1`,
	"colAuto": `ScheduledCallsList-module__col-auto___ai1QY`,
	"medicalTabs": `ScheduledCallsList-module__medical-tabs___jbJCf`,
	"medicalTableNew": `ScheduledCallsList-module__medical-table-new___l71wV`,
	"noPagination": `ScheduledCallsList-module__no-pagination___xu5fo`,
	"medicalTableEmpty": `ScheduledCallsList-module__medical-table-empty___p9Xly`,
	"iconBtn": `ScheduledCallsList-module__icon-btn___zwaKV`,
	"searchIcon": `ScheduledCallsList-module__search-icon___sCgPq`,
	"disableSelect": `ScheduledCallsList-module__disable-select___k01Sp`,
	"breakWord": `ScheduledCallsList-module__break-word___Cl81e`,
	"popupClearBtn": `ScheduledCallsList-module__popup-clear-btn___ErhWC`,
	"scrollMB20": `ScheduledCallsList-module__scroll-m-b-20___hKMck`,
	"patientContainer": `ScheduledCallsList-module__patientContainer___VFJ5e`,
	"table": `ScheduledCallsList-module__table___P7vdt`,
	"noPagination": `ScheduledCallsList-module__noPagination___hld1k`,
	"empty": `ScheduledCallsList-module__empty___nEofb`,
	"nonPatientContainer": `ScheduledCallsList-module__nonPatientContainer___d24Og`
};
module.exports = ___CSS_LOADER_EXPORT___;
